// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__5ZhC8","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3UIHY"};